import { ReactElement } from 'react'

import { Routes } from '@shared/routes'

import './shared/styles/global.css'

export const App = (): ReactElement => {
  return <Routes />
}
